import { render } from "./ProgramSubmissionRating.vue?vue&type=template&id=9efcad68"
import script from "./ProgramSubmissionRating.vue?vue&type=script&lang=ts"
export * from "./ProgramSubmissionRating.vue?vue&type=script&lang=ts"
script.render = render
/* custom blocks */
import block0 from "./ProgramSubmissionRating.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


export default script